import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ApiResource } from '../../resources/api.resource';

declare var $: any;

@Component({
  selector: 'products-component',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  @Input('productsHtml') productsHtml;
  @Input('responseUuid') responseUuid;

  @Output() uuid: EventEmitter<any> = new EventEmitter();

  constructor(private apiResource: ApiResource) { }

  ngOnInit() {
  }

  redireccionarAPaginaExistente(uuid) {

    this.uuid.emit(uuid);
    $(".lg-menu").fadeOut();
  }


  showModal(id) {
    const $inp = (name = '', isRadio = false) => {
      return $(`[name="support-${name}"]${isRadio ? ':checked' : ''}`).val();
    };

    $('.page-modal .modal').removeClass('active');

    if (id === 3) {
      let data = {};
      const getInfo = () => data;

      const solicitud = $inp('solicitud', true);
      if (solicitud) { data = { ...data, solicitud }; }

      const mensage = $inp('mensage');
      if (mensage) { data = { ...data, mensage }; }

      const email = $inp('email');
      if (email) { data = { ...data, email }; }

      const nombre = $inp('nombres');
      if (nombre) { data = { ...data, nombre }; }

      const primerApellido = '555555';
      if (primerApellido) { data = { ...data, primerApellido }; }

      const tipoCorreo = '3';
      if (tipoCorreo) { data = { ...data, tipoCorreo }; }

      const tipoSolicitud='3';
      if (tipoSolicitud) { data = { ...data, tipoSolicitud }; }

      let to = JSON.parse(localStorage.getItem("configuracion"));

      //console.log('en envio de correo');
      let body = {
        form_name: 'Davivienda Form Contacto',
        form_data: data,
        to: to
      };

      this.apiResource.sendEmail(body).subscribe(resp => {
        if (resp.response == 'Success.') {
          $('.page-modal .modal-' + id).addClass('active');
          $('.page-modal form')[0].reset();
        } else {
          this.toggleModal();
          alert('Ha ocurrido un error, vuelve a intentarlo en unos momentos');
        }
      }, err => {
        this.toggleModal();
        alert('Ha ocurrido un error, vuelve a intentarlo en unos momentos');
      });

    } else {
      $('.page-modal .modal-'+id).addClass('active');
    }

  }


  toggleModal(isLast = false) {
    const modalForm = $('.page-modal');

    if (modalForm.hasClass('active')) {
      $('body').removeClass('overflow-hidden');
    } else {
      $('body').addClass('overflow-hidden');
    }

    modalForm.toggleClass('active');

    if (isLast) {
      this.showModal(1);
    }
  }

  onlyLetters(event) {
    let keyCode = event['keyCode'] || 0;
    if (!(keyCode < 48 || keyCode > 57)) {
      event.preventDefault();
    }
  }

  readLocalStorageValue(key) {
    return localStorage.getItem(key);
}



}
